<template>
	<el-container id="guide">
		<div v-loading="loading">
			<div class="guide" v-if="guideList.length!=0">
				<div class="titBox" style="margin-top:0;">
					<p class="tit">报考指南</p>
				</div>
        	    <div class="guide_text">
        	        <p @click="guide_text(item)" class="guide_text_p" v-for="(item,i) in guideList" :key="i"><i class="iconfont">&#xe67c;</i>{{item.title}}<i class="iconfont iconfont_right">&#xe63a;</i></p>
        	    </div>
				<div class="paging">
					<el-pagination
    				  @size-change="handleSizeChange"
    				  @current-change="handleCurrentChange"
    				  :current-page="params.page"
    				  :page-sizes="[10, 20, 30, 40]"
    				  :page-size="params.limit"
    				  layout="total, sizes, prev, pager, next, jumper"
    				  :total="total">
    				</el-pagination>
				</div>

        	</div>
			<div class="nodata" v-else>
				<img :src="nodataImg">
				<p>待更新</p>
			</div>
		</div>
        
	</el-container>
</template>

<script>
export default {
	name: 'guide'
	,data () {
		return {
            guideList:[],
			loading:false,
			// currentPage4:1,
			params:{
				page:1,
				limit :10
			},
			total:0
		}
	}
	,mounted:function(){
		// console.log(this.$route.query.page);
		this.getguide()
	}
	,watch:{
		total(){

		}
	}
	,computed:{

	}
	,methods:{
		// pageSize 改变时会触发
		handleSizeChange(data){
			// console.log(111);
			// console.log(data);
			this.params.limit  = data
			this.getguide()
		},
		// currentPage 改变时会触发
		handleCurrentChange(data){
			// console.log(222);
			// console.log(data);
			this.params.page = data
			this.getguide()
		},
		// 跳转
		guide_text(data){
			// console.log(data);
			this.$router.push({
				name:'guide_text',
				query:{
					id:data.id,
					page:this.$route.query.page
				}
			});
		},
		//列表
		getguide(){
			this.loading = true
			// console.log(this.$store.state.grade_id);
			let serverSrc=this.global.serverSrc
			,qianzui=this.global.qianzui;
			let token=this.$cookies.get("token")
			let query=this.$route.query;
			this.bijiloading = true
			this.params.news_type = "2"
			this.params.grade_id = this.$store.state.grade_id   //班级id
			this.$ajax.get(serverSrc + qianzui + "/news/list",{params:this.params})
			.then(res=>{
				this.guideList = res.data.data.data
				this.total = res.data.data.total
				this.loading = false
				// console.log(res);
				// console.log(res.list.data);
			})
		}
	}
	,destroyed:function(){
		window.removeEventListener('scroll',this.getScrollPosition,false)
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/info/guide.vue